export default "__VITE_ASSET__ztzwDIal__"